import angular from 'angular'
import checkboxDirective from './checkboxDirective'

export default angular
    .module('app.checkbox2', [])
    .directive('checkbox2', checkboxDirective)
    .name



// WEBPACK FOOTER //
// ./src/components/checkbox2/index.js